import React, { Component } from 'react';
import Lottie from 'react-lottie';
import * as Colyseus from "colyseus.js";

import styles from "components/AnagramMagic/PlayerStyles.module.scss";

import StarImg from "images/AnagramMagic/star.png";
import CrossImg from "images/AnagramMagic/cross.png";

export default class Player extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pointComponents: [],
            displayScore: 0,
            showIfBonus: false,
        }
    }

    componentDidMount() {
        //const $ = Colyseus.getStateCallbacks(this.props.room);
        //$(this.props.room?.state).players[this.props.player.id].anagramData.listen("score", (value, prevValue) => {
        //    if (value > 0) {
        //        let pointComponents = [...this.state.pointComponents];
        //        pointComponents.push(<div key={`${this.props.player.id}-scoreAdd-${value}`} className={`${styles.pointAdd} ${this.props.player.anagramData.isBonusIncrease && styles.bonus}`}>+{value - prevValue}</div>);
        //        this.setState({ pointComponents });
        //        setTimeout(() => {
        //            pointComponents = [...this.state.pointComponents];
        //            pointComponents.shift();
        //            this.setState({ pointComponents });
        //        }, 2000);
        //    }

        //    let displayScore = this.state.displayScore;
        //    this.setState({ showIfBonus: this.props.player.anagramData.isBonusIncrease, });
        //    let interval = setInterval(() => {
        //        if (displayScore < value) {
        //            displayScore++;
        //            this.setState({ displayScore });
        //        } else if (displayScore > value) {
        //            displayScore--;
        //            this.setState({ displayScore });
        //        } else {
        //            this.setState({ showIfBonus: false });
        //            clearInterval(interval);
        //        }
        //    }, 100);
        //});
    }

    componentWillReceiveProps(prevProps) {
        
    }


    render() {
        return (
            <div id={`player-${this.props.player.id}`} className={`${styles.player} ${this.props.left ? "" : styles.reverse} ${this.props.player.showPlayer && styles.show}`}>
                <div id={`potato-${this.props.player.id}`} className={`${styles.potato}`}>
                    <div className={`${styles.nameAnchor} ${!this.props.left && styles.right}`} >
                        <div className={`${styles.name} ${!this.props.left && styles.right}`}>{this.props.player.name}</div>
                    </div>
                    <div className={`${styles.readyBox} ${this.props.player.anagramData.ready && styles.show}`}>READY</div>
                    <img style={{ width: "100%", height: "100%", padding: "5%", objectFit: "contain" , transform: "translateY(-5%)" }} src={this.props.player.avatar} alt="avatar" />
                </div>
                <div className={`${styles.textSection}`}>
                    <div className={`${styles.answerBox} ${this.props.player.anagramData.showAnswer && styles.show}`}>
                        <div className={styles.answerText}>{this.props.player.anagramData.answer}</div>
                        <div className={`${styles.arrow} ${styles.bg}`} />
                        <div className={styles.arrow} />
                        <div className={`${styles.answerValidation} ${this.props.player.anagramData.showValidation && styles.show}`} alt="answer validation">
                            <img src={this.props.player.anagramData.isCorrect ? StarImg : CrossImg} alt="star-cross"/> 
                            {
                                this.props.player.anagramData.isCorrect &&
                                <div className={styles.count}>{this.props.player.anagramData.earnedPoints + this.props.player.anagramData.bonusPoints}</div>
                            }
                        </div>
                    </div>
                    <div className={`${styles.pointsRow}`}>
                        <img src={StarImg} className={`${styles.star}`} alt="player star"/>
                        {/*<div className={`${styles.points} ${this.state.showIfBonus && this.props.player.anagramData.isBonusIncrease && styles.bonus}`}>{this.state.displayScore}</div>*/}
                        <div className={`${styles.points} ${this.state.showIfBonus && this.props.player.anagramData.isBonusIncrease && styles.bonus}`}>{this.props.player.anagramData.score}</div>

                    </div>
                    {
                        this.state.pointComponents
                    }
                </div>
            </div>
        )
    }
}